<template>
	<inertia-head title="Dashboard" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Coupons Management</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Coupons List</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="text-end mb-4">
			<button @click="viewCouponContentModal(0,'add')" class="btn btn-alt-primary">
				<i class="fa fa-plus me-1"></i>
				Generate Coupons
			</button>
		</div>
		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-title"></div>
				<div class="block-options">
					<div class="input-group">
						<div class="input-group-prepend"><span class="input-group-text">Filter By Membership</span></div>
						<select v-model="filter" class="form-select">
							<option value="ALL">ALL</option>
		                    <option value="BCC">BCC</option>
		                    <option value="SILVER">SILVER</option>
		                    <option value="GOLD">GOLD</option>
		                    <option value="DIAMOND">DIAMOND</option>
		                    <option value="PLATINUM">PLATINUM</option>
		                    <option value="PLATINUM COUPLE">PLATINUM COUPLE</option>
						</select>
					</div>
				</div>
			</div>
			<div class="block-content block-content-full">
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead>
							<tr>
								<th>Membership</th>
								<th>Months</th>
								<th>Type</th>
								<th>Coupon</th>
								<th>Amount</th>
								<th>Limit</th>
								<th>Reuse</th>
								<th>Expiry</th>
								<th>Status</th>
								<th>Created At</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(coupon, c_index) in coupons.data" class="fs-sm">
								<td>{{coupon.membership}}</td>
								<td>{{coupon.applicable_months}}</td>
								<td>{{coupon.coupon_type}}</td>
								<td>{{coupon.coupon_code}}</td>
								<td>{{coupon.amount}}</td>
								<td>{{coupon.limit_use}}</td>
								<td>{{coupon.is_reuse==1?'YES':'NO'}}</td>
								<td>{{coupon.expiry}}</td>
								<td>{{coupon.status}}</td>
								<td>{{coupon.created_at}}</td>
								<td class="text-end">
									<button v-if="coupon.status=='Used'" type="button" class="btn btn-sm btn-alt-info" disabled="" title="This button is disabled"><i class="fa fa-pencil-alt"></i></button>
									<button v-else @click="viewCouponContentModal(c_index,'update')" type="button" class="btn btn-sm btn-alt-info" title="Update the details"><i class="fa fa-pencil-alt"></i></button>
								</td>
							</tr>
							<tr v-if="coupons.data.length <= 0">
								<td colspan="11" class="mb-0 fw-semibold text-center p-5">NO COUPONS FOUND.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="coupons.data.length > 0" :collections="coupons"/>
			</div>
		</div>
		<add-update-coupon-modal ref="addUpdateCouponModal" :filter="filter" :content="selectedCouponContent"/>
	</div>
</template>

<script>
import { onMounted, watch, ref, reactive } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'
import AddUpdateCouponModal from '../../Components/Admin/AddUpdateCouponModal'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia';

export default {
	layout: AuthLayout,
	props: {
		coupons		: Object,
		filter 		: String,
		api_response: Object
	},
	components:{AddUpdateCouponModal},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const filter = ref(props.filter);

		const action = ref('add');

		const toast = createToaster();

		const selectedCouponContent = reactive({});

		const addUpdateCouponModal = ref(null);

		const viewCouponContentModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedCouponContent.coupon_uuid 		= props.coupons.data[_index].coupon_uuid;
				selectedCouponContent.membership 		= props.coupons.data[_index].membership;
				selectedCouponContent.applicable_months = props.coupons.data[_index].applicable_months;
				selectedCouponContent.prefix_code 		= props.coupons.data[_index].prefix_code;
				selectedCouponContent.suffix_code 		= props.coupons.data[_index].suffix_code;
				selectedCouponContent.coupon_code 		= props.coupons.data[_index].coupon_code;
				selectedCouponContent.coupon_type 		= props.coupons.data[_index].coupon_type;
				selectedCouponContent.amount 			= props.coupons.data[_index].amount;
				selectedCouponContent.expiry_date 		= props.coupons.data[_index].expiry_date;
				selectedCouponContent.expiry_time 		= props.coupons.data[_index].expiry_time;
				selectedCouponContent.limit_use 		= props.coupons.data[_index].limit_use;
				selectedCouponContent.is_reuse 			= props.coupons.data[_index].is_reuse;
				selectedCouponContent.status 			= props.coupons.data[_index].status;
				selectedCouponContent.c_source 			= props.coupons.data[_index].c_source;
			}

			addUpdateCouponModal.value.setCouponContent(_action,selectedCouponContent);

			addUpdateCouponModal.value.toggleModal();

		}

		watch(filter, (value,old_value) => {
			
			if(value!=old_value)
			{
				var param = {filter:value}

				Inertia.get(
						'/admin/coupons', param,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['coupons', 'filter']
						}
					)
			}
		})

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action.value=='add' ? 'generated' : 'updated';
				var action_msg1 = action.value=='add' ? 'generate' : 'update';

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action_msg1, { type: "error"});
				}
			}
		})

		return{
			filter,
			action,
			toast,
			viewCouponContentModal,
			selectedCouponContent,
			addUpdateCouponModal
		}
	},
}
</script>
